module.exports = __webpack_public_path__ + "img/ingot.146fce48.svg";